import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Guards
import { AuthGuard } from '@core/providers/guards/auth/auth.guard';

// Components
import { NotPageFoundComponent } from '@views/public/404/not-page-found.component';
import { UnauthorizedComponent } from '@views/public/401/unauthorized.component';
import { RoleGuard } from '@core/providers/guards/role/role.guard';
import { UserRole } from '@core/models/maintainer.interface';



const routes: Routes = [{
    path: 'depreciation', canActivate: [ RoleGuard ], canActivateChild: [ AuthGuard ],
    data: { roles: [ UserRole.ADMINISTRATOR ] }, title: 'Sodimac | Rental | Depreciation',
    loadChildren: () => import('./views/private/depreciation/depreciation.module').then( m => m.DepreciationModule )
  }, {
    path: 'warranty', canActivate: [ RoleGuard ], canActivateChild: [ AuthGuard ],
    data: { roles: [ UserRole.ADMINISTRATOR, UserRole.COLLABORATOR ] }, title: 'Sodimac | Rental | Warranty',
    loadChildren: () => import('./views/private/warranty/warranty.module').then( m => m.WarrantyModule ),
  }, {
    path: 'maintainer', canActivate: [ RoleGuard ], canActivateChild: [ AuthGuard ],
    data: { roles: [ UserRole.ADMINISTRATOR ] }, title: 'Sodimac | Rental | Maintainer',
    loadChildren: () => import('./views/private/maintainer/maintainer.module').then( m => m.MaintainerModule ),
  }, {
    path: 'home', canActivate: [ AuthGuard ], title: 'Sodimac | Rental | Home',
    loadComponent: () => import('./views/private/home/home.component').then( m => m.HomeSComponent ),
  },
  { path: '404', component: NotPageFoundComponent, title: 'Sodimac | Rental | 404' },
  { path: '401', component: UnauthorizedComponent, title: 'Sodimac | Rental | 401' },
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
